<template>
	<div class="container relative mb-8 flex flex-wrap">
		<div
			v-if="partnerName === 'carsales'"
			class="contained-section w-full bg-carsales-primary"
			:class="whitelabel.styles?.bg?.borderRadius"
		>
			<div class="w-full lg:w-2/3">
				<h2 class="mb-4 text-white">What is car subscription?</h2>
				<div class="w-full space-y-4 xl:w-2/3">
					<p class="text-white">
						Car subscription gives you access to a vehicle without
						the upfront cost or long term lock in of ownership.
					</p>
					<p class="text-white">
						You choose your car. Pay a simple weekly fee. Swap or
						pause when your needs change.
					</p>
					<p class="text-white">
						It is designed for drivers who want flexibility, not
						commitment.
					</p>
				</div>
			</div>
		</div>

		<div
			v-if="partnerName === 'erinliving'"
			class="contained-section w-full bg-erinliving-primary"
			:class="[
				whitelabel.styles?.bg?.borderRadius,
				whitelabel.styles?.bg?.color,
			]"
		>
			<div class="w-full lg:w-2/3">
				<h1 class="mb-4 text-3xl text-white">
					Cars available for subscription
				</h1>
				<div class="w-full xl:w-2/3">
					<p class="text-white">
						Forget financing, balloon payments, interest,
						depreciation, insurance, rego and all the variable
						maintenance and servicing costs. We'll take care of all
						this for you. There are no lock-in contracts. Stop or
						swap with just 2 weeks notice.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
const { partnerName } = useGetPartnerName()
const { whitelabel } = useWhitelabelsStyles()
</script>
